import React from 'react';

const StarRating = ({ rating }) => (
  <div className="flex items-center gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <span key={i} className={`text-xl ${i < rating ? 'text-yellow-400' : 'text-gray-200'}`}>★</span>
    ))}
  </div>
);

const TestimonialViewModal = ({ testimonial, onClose }) => {
  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <h2 className="text-xl font-bold text-gray-800">Testimonial Details</h2>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-500 transition"
          >
            ✕
          </button>
        </div>

        <div className="p-6 space-y-5">
          {/* Logo + Author */}
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-xl overflow-hidden bg-gray-100 border border-gray-200 flex-shrink-0">
              <img
                src={testimonial.logo}
                alt="logo"
                className="w-full h-full object-cover"
                onError={e => { e.target.src = 'https://via.placeholder.com/64'; }}
              />
            </div>
            <div>
              <h3 className="text-base font-bold text-gray-800">{testimonial.authorName}</h3>
              {testimonial.jobRole && (
                <p className="text-sm text-gray-400 mt-0.5">{testimonial.jobRole}</p>
              )}
              <div className="mt-1">
                <StarRating rating={testimonial.rating} />
              </div>
            </div>
          </div>

          {/* Heading */}
          <div className="bg-gray-50 rounded-xl p-4">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-1">Heading</p>
            <p className="text-sm font-bold text-gray-800">{testimonial.heading}</p>
          </div>

          {/* Content */}
          <div className="bg-gray-50 rounded-xl p-4">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Review</p>
            <p className="text-sm text-gray-700 leading-relaxed">"{testimonial.content}"</p>
          </div>

          {/* Rating */}
          <div className="bg-yellow-50 rounded-xl p-4">
            <p className="text-xs font-semibold text-yellow-600 uppercase tracking-wide mb-2">Rating</p>
            <div className="flex items-center gap-3">
              <StarRating rating={testimonial.rating} />
              <span className="text-sm font-bold text-gray-700">{testimonial.rating} / 5</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            type="button"
            onClick={onClose}
            className="w-full py-2.5 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 font-medium transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialViewModal;